import React, { useEffect, useRef, useState } from 'react';
import { AddContainer, Component4, PatientViewContainer, Texts, Text, Switch, HeaderPart, FooterPart, SaveButton } from './Style';
import InputComponent from 'src/components/shared/Form/Input/index.js';
import { palette, shadows } from 'src/config/theme.js';
import { alpha } from '@mui/material';
import SwitchComponent from 'src/components/shared/Form/Switch';
import { ReactComponent as CloseIcon } from '../../../../../../src/assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../../../src/assets/images/add-square.svg';
import ButtonComponent from 'src/components/shared/Button';
import { postMedicalRecordsRequest } from 'src/modules/app/store/appActions';
import { useDispatch } from "react-redux";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import toast from 'src/utils/toast';
import dayjs from 'dayjs';
import useResponsive from 'src/components/hooks/useResponsive';
import useAppointmentDetails from '../../UseAppointmentDetails';

const validationSchema = Yup.object().shape({
    notes: Yup.string().required('notes are required')
})

function NotesTabForm({ onClose, fetchNotes }) {
    const { isMobile, isTablet, isDesktop } = useResponsive();
    const { PatientId, user, appointmentId } = useAppointmentDetails();
    const dispatch = useDispatch();
    const recognitionRef = useRef(null);
    const notesRef = useRef('');
    const [recording, setRecording] = useState(false);


    const handleSubmit = async (values, { resetForm }) => {
        const now = dayjs();

        const formattedDate = now.format('YYYY-MM-DD');
        const formattedTime = now.format('HH:mm');

        try {
            const notesData = {
                notes: values.notes,
                date: formattedDate,
                time: formattedTime,
                patientView: "off",
                recordType: 'note',
                tokenappointment: appointmentId,
                patient: PatientId,
                user,
            }
            const response = await new Promise((resolve, reject) => {
                dispatch(postMedicalRecordsRequest(notesData, resolve, reject));
            });

            console.log("Note added successfully", response);
            toast.success(response.message);

            if (response?.medicalRecord?.id && fetchNotes) {
                fetchNotes();
            }
            onClose();

            resetForm();


        }
        catch (error) {
            console.log(error.message || 'Failed to add notes');
            toast.error(error.message || 'Failed to add notes');
        }
    }

    return (
        <>
            <Formik
                initialValues={{
                    notes: '',
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, errors, touched, handleBlur, handleSubmit, handleChange, setFieldValue }) => (
                    <Form >
                        {(() => { notesRef.current = values.notes; })()}
                        <HeaderPart>
                            Add Note
                            <CloseIcon width={isMobile || isTablet ? 18 : 24}
                                height={isMobile || isTablet ? 18 : 24} onClick={onClose} style={{ cursor: 'pointer' }} />
                        </HeaderPart>
                        <AddContainer>
                            <Component4>
                                <Texts>Note</Texts>
                                <InputComponent
                                    name="notes"
                                    value={values.notes}
                                    variant="outlined"
                                    placeholder="Enter note.."
                                    fullWidth
                                    multiline
                                    rows={4}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.notes && Boolean(errors.notes)}
                                    helperText={touched.notes && errors.notes}
                                    sx={{
                                        backgroundColor: palette.gery.white,
                                        boxShadow: shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            padding: '16px 18px',
                                            borderRadius: '12px',
                                            height: '120px',
                                            alignItems: 'flex-start',
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                        },
                                    }}
                                />
                            </Component4>
                            <Component4>
                                <Texts>Voice Recording</Texts>
                                <PatientViewContainer>
                                    <Text>Off</Text>
                                    <Switch>
                                        <SwitchComponent
                                            name="voiceRecording"
                                            checked={recording}
                                            onChange={() => {
                                                const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
                                                if (!SR) {
                                                    toast.error('Voice recognition is not supported in this browser');
                                                    return;
                                                }
                                                if (!recording) {
                                                    if (!recognitionRef.current) {
                                                        const recog = new SR();
                                                        recog.lang = 'en-IN';
                                                        recog.continuous = true;
                                                        recog.interimResults = true;
                                                        recog.onresult = (e) => {
                                                            let finalText = '';
                                                            for (let i = e.resultIndex; i < e.results.length; i++) {
                                                                if (e.results[i].isFinal) {
                                                                    finalText += e.results[i][0].transcript;
                                                                }
                                                            }
                                                            if (finalText) {
                                                                const base = notesRef.current || '';
                                                                const merged = `${base}${base ? ' ' : ''}${finalText}`.trim();
                                                                setFieldValue('notes', merged);
                                                                notesRef.current = merged;
                                                            }
                                                        };
                                                        recog.onend = () => {
                                                            if (recording) {
                                                                try { recog.start(); } catch (_) {}
                                                            }
                                                        };
                                                        recognitionRef.current = recog;
                                                    }
                                                    try { recognitionRef.current.start(); } catch (_) {}
                                                    setRecording(true);
                                                } else {
                                                    try { recognitionRef.current && recognitionRef.current.stop(); } catch (_) {}
                                                    setRecording(false);
                                                }
                                            }}
                                            sx={{ marginTop: 0 }}
                                        />
                                    </Switch>
                                    <Text>On</Text>
                                </PatientViewContainer>
                            </Component4>

                        </AddContainer>
                        <FooterPart >
                            <ButtonComponent
                                variant="none"
                                startIcon={<CloseIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} sx={{ color: palette.primary.main }} />}
                                onClick={onClose}
                            >
                                Cancel
                            </ButtonComponent>
                            <SaveButton
                                type="submit"
                                variant="outlined"
                                startIcon={<AddIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} sx={{ color: palette.primary.main }} />}

                            // onClick={handleSubmit ? () => handleSubmit() : null}
                            >
                                Save
                            </SaveButton>
                        </FooterPart>
                    </Form>
                )}
            </Formik>
        </>

    )
}

export default NotesTabForm
